import { AdproductsAnalyticsListingFilterType, type ClientAdProductType } from '@zg-rentals/rental-manager-env';
import { AdproductsConstants } from '../constants';

const { ProductCodes, ProductTypes, PackageTypes, RocketshipTypes } = AdproductsConstants;

export const adproductsUtils = {
  getOneYearMonthRanges: (date = new Date()) => {
    const ranges = [];
    date.setDate(1);
    const endDate = new Date(date.valueOf());
    const startDate = new Date(date.valueOf());
    startDate.setMonth(startDate.getMonth() - 11);

    while (startDate <= endDate) {
      ranges.push([startDate.getFullYear(), startDate.getMonth()]);
      startDate.setMonth(startDate.getMonth() + 1);
    }

    return ranges;
  },
  createDateFromYearMonth(year: number, month: number) {
    const date = new Date();
    date.setFullYear(year);
    // Java month is 1 based and js month is 0 based so subtract 1
    date.setMonth(month - 1, 1);
    return date;
  },
  hasPackage(productTypes: Array<string> = []) {
    return productTypes.some((productType) => PackageTypes.has(productType));
  },
  hasRocketship(productTypes = []) {
    return productTypes.some((productType) => RocketshipTypes.has(productType));
  },
  hasReit(productTypes = []) {
    return productTypes.some((productType) => productType === ProductCodes.SINGLE_FAMILY);
  },
  mapProductTypesWithPackageCheck(productTypes: Array<string> = []) {
    const hasPackage = this.hasPackage(productTypes);
    let mappingTypes = productTypes;
    if (hasPackage) {
      mappingTypes = productTypes.filter((productType) => PackageTypes.has(productType));
    }
    const set = new Set(mappingTypes.map((productType) => ProductTypes[productType]));
    return [...set];
  },
  mapProductTypes(productTypes: Array<string> = [], filterType?: AdproductsAnalyticsListingFilterType) {
    const set = new Set(productTypes.map((productType) => this.getProductTypeName(productType, filterType)));
    return [...set];
  },
  getProductTypeName(productTypeCode: ClientAdProductType | string, filterType?: AdproductsAnalyticsListingFilterType) {
    switch (filterType) {
      case AdproductsAnalyticsListingFilterType.TIER2_OVER_25:
        return 'Claimed Listing Over 25 Units';
      case AdproductsAnalyticsListingFilterType.TIER2_UNDER_25:
        return 'Claimed Listing Under 25 Units';
      case AdproductsAnalyticsListingFilterType.TIER3:
        return 'Bonus Listing';
      default:
        return ProductTypes[productTypeCode];
    }
  },
  containsOnlyPackageProducts(invoices = []) {
    if (!invoices || !invoices.length) {
      return false;
    }
    return invoices
      .flatMap((invoice) => {
        // @ts-ignore
        if (invoice.adproductCodes.some((code) => PackageTypes.has(code))) {
          // @ts-ignore
          return invoice.adproductCodes.filter((code) => PackageTypes.has(code));
        }
        // @ts-ignore
        return invoice.adproductCodes;
      })
      .every((code) => PackageTypes.has(code));
  },
  containsOnlyFlatFeeFeedConnect(invoices = []) {
    if (!invoices || !invoices.length) {
      return false;
    }
    return (
      invoices
        // @ts-ignore
        .flatMap((invoice) => invoice.adproductCodes)
        .every((code) => code === ProductCodes.FLAT_FEE_FEED_CONNECT)
    );
  },
  containsPayPerLeadWithWaitlist(invoices = []) {
    if (!invoices || !invoices.length) {
      return false;
    }
    return invoices.some(
      // @ts-ignore
      (invoice) => invoice.adproductCodes.includes(ProductCodes.PAY_PER_LEAD) && invoice.waitlistedDays,
    );
  },
};
